import {UserRepository} from '../repository/UserRepository';
import {AssignRoleRequest, DashboardUser} from '../models/user.model';
import {AppError, ErrorType} from '../../../Data/config/AppError';

export class AssignRoleUseCase {
  private readonly userRepository: UserRepository;

  constructor (userRepository: UserRepository) {
    this.userRepository = userRepository;
  }

  async execute (roleData: AssignRoleRequest): Promise<DashboardUser> {
    // Validate required fields
    if (!roleData.userId || roleData.userId < 1) {
      throw new AppError('معرف المستخدم صحيح مطلوب', ErrorType.VALIDATION);
    }

    if (!roleData.roleId || roleData.roleId < 1) {
      throw new AppError('معرف الدور صحيح مطلوب', ErrorType.VALIDATION);
    }

    try {
      // Assign the role to the user
      const updatedUser = await this.userRepository.assignRole(roleData);

      return updatedUser;
    } catch (error) {
      // Don't handle error here - just throw it so it can be handled at the component level
      if (error instanceof AppError) {
        throw error;
      }
      throw AppError.fromApiError(error);
    }
  }
}
